/**
 * The screenshot a customer attached when they said they had paid, shown to
 * whoever is deciding whether to confirm it. A picture is shown as a thumbnail
 * that opens full size; a PDF slip is just a link.
 */
export const ClaimReceipt = ({ url }) => {
  if (!url) return <span className="muted">No screenshot attached</span>;
  if (url.toLowerCase().endsWith('.pdf')) {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        Open their payment slip (PDF)
      </a>
    );
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" className="meter-photo meter-photo-sm" title="Open full size">
      <img src={url} alt="Payment screenshot sent by the customer" />
    </a>
  );
};
